import { Button, Form, Input } from 'antd';
import './loginEmail.css';

interface LoginEmailProps {
  onFinish: (data: { email: string }) => void;
}

export const LoginEmail = ({ onFinish }: LoginEmailProps) => {
  const [form] = Form.useForm();

  return (
    <Form
      form={form}
      name='login'
      className='space-y-4 login-form-container'
      onFinish={onFinish}
      layout='vertical'
      size='large'
    >
      <Form.Item
        label="Email"
        name='email'
        className="login-email-form-item"
        rules={[
          {
            required: true,
            message: 'Please enter your email!',
            type: 'email',
          },
        ]}
      >
        <Input
          placeholder='email@email.com'
          className='input-no-border'
        />
      </Form.Item>

      <div className="text-sm md:text-base text-white/90 text-center mb-4 font-barlow">
        We'll send you an access link to your email for secure, password-free login.
      </div>

      <Form.Item>
        <Button type='primary' htmlType='submit' className='w-full font-android hover-3d-no-shadow'>
          SEND ACCESS LINK
        </Button>
      </Form.Item>
    </Form>
  );
};
